import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

const BreadNav = ({ title, backTo, children }) => {
    const { t } = useTranslation();
    return <nav aria-label="breadcrumb">
        <ol className="breadcrumb bread-nav">

            {backTo ? <li className="back"><NavLink to={backTo}><i className="fa fa-chevron-left"></i> {t('Back')}</NavLink></li>
                : ''}
            {children}
            {title ? <li className="breadcrumb-item active" aria-current="page">{title}</li> : ""}
        </ol>
    </nav >;
};

export default BreadNav;